'use client'

import { FC, useEffect, useState } from 'react'

import { usePathname, useRouter } from 'next/navigation'

import { LoadingPage } from '@/components/commons'
import { useAuthProvider } from '@/contexts/auth/AuthProvider'
import { routerPaths } from '@/utils/constants/routes'

import { IPrivateRouteProps } from './types'

const PrivateRoute: FC<IPrivateRouteProps> = ({
  children,
  userInformations,
}) => {
  const { isLogoutLoading } = useAuthProvider()

  const router = useRouter()
  const pathName = usePathname()

  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    const hasToken = !!userInformations?.token

    // Se não houver token em uma rota privada, redireciona para login.
    if (
      !hasToken &&
      pathName.startsWith(routerPaths.private.dashboard.pathName)
    ) {
      router.replace(routerPaths.public.login.default)
      return
    }

    // Se houver token em rota pública (caso middleware não tenha pegado), envia para dashboard.
    if (
      hasToken &&
      (pathName === routerPaths.public.login.default ||
        pathName === routerPaths.public.forgotPassword.default)
    ) {
      router.replace(routerPaths.private.dashboard.default)
      return
    }

    setIsChecking(false)
  }, [pathName, router, userInformations])

  if (isChecking) return <LoadingPage />

  return (
    <>
      {children}
      {isLogoutLoading && <LoadingPage />}
    </>
  )
}

export default PrivateRoute
